import { Mail, ShieldCheck, MessageCircle } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import { FadeUp } from "@/components/Reveal";
import { EMAILS } from "@/config";

const CHANNELS = [
  {
    icon: Mail,
    title: "Genel",
    email: EMAILS.hello,
    text: "Five Star hakkında merak ettiklerin, basın ve iş birliği talepleri için.",
    testid: "contact-hello-mailto",
  },
  {
    icon: MessageCircle,
    title: "Destek",
    email: EMAILS.support,
    text: "Üyelik işlemleri, teknik sorunlar ve hesap konuları için.",
    testid: "contact-support-mailto",
  },
  {
    icon: ShieldCheck,
    title: "Gizlilik",
    email: EMAILS.privacy,
    text: "Kişisel verilerin ve gizlilik haklarınla ilgili talepler için.",
    testid: "contact-privacy-mailto",
  },
];

export default function ContactPage() {
  return (
    <>
      <PageHeader silk={2}
        testid="contact-header"
        eyebrow="İletişim"
        titleLines={["Bize", "yazın."]}
        lede="Five Star ile ilgili her konuda bize e-posta ile ulaşabilirsin. Mesajını ilgili ekibe yönlendirmek için aşağıdaki kanallardan birini seç."
      />
      <section className="bg-ivory pb-24 sm:pb-32 px-6">
        <div className="max-w-5xl mx-auto grid sm:grid-cols-3 gap-5">
          {CHANNELS.map((c, i) => (
            <FadeUp key={c.title} delay={i * 0.1}>
              <div className="h-full bg-white/90 border border-burgundy/10 rounded-[6px] p-8 flex flex-col hover:border-burgundy/25 transition-colors duration-300">
                <span className="w-10 h-10 rounded-full border border-gold/50 flex items-center justify-center">
                  <c.icon className="w-[18px] h-[18px] text-burgundy" aria-hidden="true" />
                </span>
                <h2 className="mt-5 font-serif text-2xl text-ink">{c.title}</h2>
                <p className="mt-2.5 text-sm font-light text-ink-soft/90 leading-relaxed flex-1">{c.text}</p>
                <a
                  href={`mailto:${c.email}`}
                  data-testid={c.testid}
                  className="mt-7 inline-flex items-center gap-2 text-sm font-medium text-burgundy border-b border-burgundy/30 hover:border-burgundy pb-1 transition-colors self-start"
                >
                  {c.email}
                </a>
              </div>
            </FadeUp>
          ))}
        </div>
        <FadeUp delay={0.25} className="max-w-5xl mx-auto mt-12">
          <p className="text-xs text-ink-muted tracking-wide text-center">
            Destek taleplerine mümkün olan en kısa sürede dönüş yapılır.
          </p>
        </FadeUp>
      </section>
    </>
  );
}
